/*

	<div class="ImagesSlider" data-paging="true" data-navigation="fade">
		<img src=".../image.jpg" class="ImagesSlider__Slide>
		<img src=".../image.jpg" class="ImagesSlider__Slide>
		<img src=".../image.jpg" class="ImagesSlider__Slide>
	</div>

 */

import $ from 'jquery';
import common from '../base/common';

class ImagesSlider{

	constructor($slider){

        this.slideClass = '.ImagesSlider__Slide';

        this.$slider = $slider;
		this.$slides = this.$slider.find(this.slideClass);

		this.options = {

			paging: 	this.$slider.data('paging') || true, // fade | horizontal
			navigation: this.$slider.data('navigation') || 'fade', // fade | horizontal
			keyboard:	this.$slider.data('keyboard') || false, // fade | horizontal
			arrows:		this.$slider.data('arrows') || false,

		};

		this.$arrowLeft		= this.$slider.find('.ImagesSlider__Arrow.__left');
        this.$arrowRight 	= this.$slider.find('.ImagesSlider__Arrow.__right')

		this.classVisibleArrow	= '__active';
		this.classActiveSlide	= '__active';
		this.currentIndex		= 0;
		this.count				= this.$slides.length;
		this.isActive			= false;

		this.pagingClick		= this.pagingClick.bind(this);
		this.onResize			= this.onResize.bind(this);
		this.keyboardNavigation = this.keyboardNavigation.bind(this);
		this.updateUI			= this.updateUI.bind(this);

		this.create();
		this.enable();

	}

    bindEvents() {

        common.$window.on('resize.imagesSlider', this.onResize);

        if (this.options.keyboard === true) {
            this.$slider.on('keydown.imagesSlider', this.keyboardNavigation);
        }

        if (this.options.arrows === true) {
            this.$prevArrow.on('click.imagesSlider', this.prevSlide)
            this.$nextArrow.on('click.imagesSlider', this.nextSlide)
        }

        if(this.options.paging === true){
            this.$paging.on('click.imagesSlider', 'button', this.pagingClick);
		}

    }

    unBindEvents(){

        common.$window.off('resize.imagesSlider', this.onResize);

        if (this.options.keyboard === true) {
            this.$slider.off('keydown.imagesSlider', this.keyboardNavigation);
        }

        if (this.options.arrows === true) {
            this.$prevArrow.off('click.imagesSlider', this.prevSlide)
            this.$nextArrow.off('click.imagesSlider', this.nextSlide)
        }

        if(this.options.paging === true){
            this.$paging.on('click.imagesSlider', 'button', this.buttonClick);
        }

    }

    create(){

    	this.$slider.addClass('__navigation-' + this.options.navigation);
        this.$wrap = $('<div class="ImagesSlider__Wrap" />');
        this.$slides.remove();
        this.$wrap.append(this.$slides);
        this.$slider.append(this.$wrap);

        if(this.options.arrows === true){

        	if(!this.$arrowLeft.length){
                this.$arrowLeft = $('<button class="ImagesSlider__Arrow __left" />');
                this.$slider.append(this.options.$arrowLeft);
			}

        	if(!this.$arrowRight.length){
                this.$arrowRight = $('<button class="ImagesSlider__Arrow __right" />');
                this.$slider.append(this.options.$arrowRight);
			}


        }

        if(this.options.paging === true){

        	this.$paging = $('<div class="ImagesSlider__Paging" />');
        	this.$slides.each((index) => {

                this.$paging.append('<button type="button" ' + (index == 0 ? 'class="__active"' : '') + ' data-index="'+index+'" />');
			})

			this.$slider.append(this.$paging);

		}

		this.$slides.eq(0).addClass(this.classActiveSlide);
        this.onResize();

	}

    enable(){

    	this.isActive = true;
		this.bindEvents();

	}

	disable(){

        this.isActive = false;
        this.unBindEvents();

	}

    onResize(){


		if(this.options.navigation == 'horizontal'){
            this.$wrap.css('height', this.$slides.eq(0).height());
            this.$wrap.css('width', this.$slides.length * common.screen.width);
            TweenMax.set(this.$wrap, {x: (common.screen.width * this.currentIndex) * -1});
            this.updateUI();
		}else{

            this.$wrap.css('width', this.$slider.parent().width());

		}

    }

    updateUI(){

    	this.$slides.removeClass(this.classActiveSlide);
    	this.$slides.eq(this.currentIndex).addClass(this.classActiveSlide);
        this.$slides.removeAttr('style');

        if(this.count > 1){
            if(this.currentIndex == 0){
                if(this.options.arrows){
                    this.$prevArrow.removeClass(this.classVisibleArrow);
                    this.$nextArrow.addClass(this.classVisibleArrow);
				}
            }else if(this.currentIndex == this.count - 1){
                if(this.options.arrows) {
                    this.$prevArrow.addClass(this.classVisibleArrow);
                    this.$nextArrow.removeClass(this.classVisibleArrow);
                }
            }

            if(this.options.paging){

            	this.$paging.find('button').removeClass('__active');
                this.$paging.find('button').eq(this.currentIndex).addClass('__active');

			}

        }

	}

    prevSlide(){

		if(this.currentIndex == 0) return;
		this.currentIndex --;
		this.moveSlider();

	}

	nextSlide(){

    	if(this.currentIndex == this.count - 1) return;
    	this.currentIndex ++;
        this.moveSlider();

	}

	moveSlider(){

        if(this.options.navigation == 'fade') {

            let tl = new TimelineMax({onComplete: this.updateUI })
            tl.add([

                TweenMax.to(this.$slides.not(':eq('+this.currentIndex+')'), 0.3, {opacity: 0}),
                TweenMax.to(this.$slides.eq(this.currentIndex), 0.3, {opacity: 1, 'z-index': 10}),
            ])

        }else{

            TweenMax.to(this.$wrap, 1, {
                x: (this.currentIndex * common.screen.width) * -1,
                ease: Power3.easeInOut,
                onComplete: this.updateUI
            })

		}

	}

	goTo(index){

		let oldIndex = this.currentIndex;
        this.currentIndex = index;

		if(this.options.navigation == 'fade'){

			let tl = new TimelineMax({onComplete: this.updateUI })
			tl.add([

                TweenMax.to(this.$slides.eq(oldIndex), 0.3, {opacity: 0}),
                TweenMax.to(this.$slides.eq(this.currentIndex), 0.3, {opacity: 1, 'z-index': 10}),
			])

		}else{

            TweenMax.to(this.$wrap, 1, { x: (this.currentIndex * common.screen.width) * -1, ease: Power3.easeInOut, onComplete: this.updateUI})

        }

	}

    keyboardNavigation(e){

		let key = e.keyCode || e.which;
		switch(key){
			case 37:
			case 80:
				this.prevSlide();
				break;
			case 39:
			case 78:
				this.nextSlide();
				break;
		}

	}

    pagingClick(e){

        this.goTo(e.currentTarget.dataset.index);
        this.$paging.find('button').removeClass('__active');
        this.$paging.find('button').eq(e.currentTarget.dataset.index).addClass('__active');

	}

}

export default ImagesSlider;



// WEBPACK FOOTER //
// ./js/components/imagesSlider.js